<div class="toast-stack" aria-live="polite" aria-atomic="true">
  <div *ngFor="let toast of toasts$ | async; trackBy: trackById"
       class="toast"
       [class.success]="toast.tone === 'success'"
       [class.error]="toast.tone === 'error'"
       [@toastIn]
       role="status">
    <app-icon *ngIf="toast.tone === 'success'" name="circle-check" class="toast-icon" aria-hidden="true"></app-icon>
    <app-icon *ngIf="toast.tone === 'error'" name="circle-exclamation" class="toast-icon" aria-hidden="true"></app-icon>
    <span class="toast-message">{{ toast.message }}</span>
    <button *ngIf="toast.actionLabel" type="button" class="toast-action" (click)="act(toast)">{{ toast.actionLabel }}</button>
    <button type="button" class="toast-close" (click)="dismiss(toast)" aria-label="Dismiss">
      <app-icon name="times" aria-hidden="true"></app-icon>
    </button>
  </div>
</div>
